/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_DescriptionInputs */

const es_settings_sources_description = /** @type {(inputs: Settings_Sources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrá las integraciones que Nexata utiliza en tiempo real para contextualizar y responder con información siempre actualizada.`)
};

const en_settings_sources_description = /** @type {(inputs: Settings_Sources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage real-time integrations Nexata uses to contextualize and respond with up-to-date information.`)
};

/**
* | output |
* | --- |
* | "Manage real-time integrations Nexata uses to contextualize and respond with up-to-date information." |
*
* @param {Settings_Sources_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_description = /** @type {((inputs?: Settings_Sources_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_description(inputs)
	return en_settings_sources_description(inputs)
});
export { settings_sources_description as "settings.sources.description" }